import type { IConfig } from "@unleash/proxy-client-react";

export const getConfig = (): IConfig => ({
  url: window.env.UNLEASH_URL,
  refreshInterval: Number(window.env.UNLEASH_REFRESH_INTERVAL),
  environment: window.env.UNLEASH_ENVIRONMENT,
  appName: window.env.UNLEASH_APP_NAME,
  clientKey: window.env.UNLEASH_APP_NAME,
});
